module.exports = __webpack_public_path__ + "static/img/10012 (2).4728634.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10012 (2).webp
// module id = c+7H
// module chunks = 14